import React, { useState } from "react";
import styles from "./Icecream.module.css";
import { actions } from "../../lib/actions";
import { useStateContext } from "../../lib/StateContext";

function Icecream({ className }) {
  const [state, dispatch] = useStateContext();
  const [demandChanged, setDemandChanged] = useState(false);
  const [justPromotedToLevel3, setJustPromotedToLevel3] = useState(null);

  const icecream = React.useMemo(() => {
    return state.icecream;
  }, [state]);

  React.useEffect(() => {
    dispatch(actions.changeActionDemand("icecream"));
    dispatch(actions.addDailyIncome("icecream"));
    setDemandChanged(true);
    setTimeout(() => {
      setDemandChanged(false);
    }, 500);
  }, [state.tick, dispatch, setDemandChanged]);

  React.useEffect(() => {
    if (state.player.xp > 100 && justPromotedToLevel3 === false) {
      setJustPromotedToLevel3(true);
      setTimeout(() => {
        setJustPromotedToLevel3(false);
      }, 10000);
    }
  }, [state.player.xp, justPromotedToLevel3]);

  return (
    <section className={`${className} ${styles.action}`}>
      <h3> Ice Cream Parlour </h3>
      <i> Making Cones at the Ice Cream Parlour.</i>
      <div className={styles.rate}>Rate: ${icecream.rate} per cone</div>
      <div className={`${styles.demand} ${demandChanged ? "highlight" : ""}`}>
        demand: <span>{icecream.demand}</span>
      </div>
      {icecream.daily > 0 && icecream.workersHired > 0 && (
        <div>
          daily income: <span>{icecream.daily}</span>{" "}
          <span>({icecream.workersHired} workers)</span>
        </div>
      )}

      <button
        className="btn btn-primary"
        disabled={icecream.demand < 1}
        onClick={() => dispatch(actions.doAction("icecream"))}
      >
        Make Ice Cream Cone
      </button>

      <div className={`${justPromotedToLevel3 ? "highlight" : ""}`}>
        {justPromotedToLevel3 && (
          <span>You have been promoted! You can hire ice cream makers</span>
        )}

        {state.player.xp >= 100 && (
          <table className="table">
            <thead>
              <tr>
                <th>Worker</th>
                <th>Income</th>
                <th>Price</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {icecream.workers.map((worker) => (
                <tr key={worker.name}>
                  <td>{worker.name}</td>
                  <td>{worker.income}</td>
                  <td>{worker.priceToHire}</td>
                  <td>
                    <button
                      disabled={state.monies.cash < worker.priceToHire}
                      className="btn btn-primary"
                      onClick={() => dispatch(actions.hireWorker(worker))}
                    >
                      Hire
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </section>
  );
}

export default Icecream;
